const NAMESPACE = "envelopeCompleted";

const KEYS = {
    envelopeCompletedPlaceholder: "envelopeCompletedPlaceholder",
    envelopeCompletedEnvelopeSelected: "envelopeCompletedEnvelopeSelected",
    envelopeCompletedEnvelopeSelectedError: "envelopeCompletedEnvelopeSelectedError"
};

const MESSAGES = {
    [KEYS.envelopeCompletedPlaceholder]: {
        value: "Is Envelope Completed Reference",
        comment: "Placeholder text for Envelope Completed formula expression when no Envelope Definition has been set."
    },
    [KEYS.envelopeCompletedEnvelopeSelected]: {
        value: `Is Envelope {'{'}{envelopeDefinitionName}{'}'} Completed{valueStr}`,
        comment:
            "Text for Envelope Completed formula expression when an Envelope Defintion has been selected and evaluated."
    },
    [KEYS.envelopeCompletedEnvelopeSelectedError]: {
        value: `There is no envelope {'{'}{envelopeDefinitionName}{'}'}, and no default value was defined for "Is Completed".`,
        comment:
            "Error text for Envelope Completed formula expression when no envelope exists for the selected Envelope Definition."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
